import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export default function GrantsPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const checkUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        // Redirect to profile with grants section
        navigate('/?tab=profile&section=grants');
      } else {
        // Redirect to home if not logged in
        navigate('/');
      }
    };
    checkUser();
  }, [navigate]);

  return null;
}
